import React from 'react'
import { Typography, Chip, Button, CircularProgress } from '@material-ui/core'
import { BLOCKER_STATUS_LABELS, BLOCKER_STATUS_COLORS, BLOCKER_CATEGORY_LABELS } from '../../constants/contextEnums'

const formatDate = (d) => {
  if (!d) return ''
  return new Date(d).toLocaleDateString()
}

const BlockersTab = ({ items, loading, onEdit, onResolve }) => {
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><CircularProgress size={20} /></div>
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No blockers. When something is preventing progress, log it here.</Typography>
  }

  const handleResolve = (blocker, e) => {
    e.stopPropagation()
    onResolve(blocker)
  }

  return items.map((blocker) => (
    <div
      key={blocker._id}
      style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', cursor: 'pointer' }}
      onClick={() => onEdit('blocker', blocker)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <Chip
          label={BLOCKER_STATUS_LABELS[blocker.status] || blocker.status}
          size="small"
          style={{ height: 20, fontSize: 11, backgroundColor: BLOCKER_STATUS_COLORS[blocker.status] || '#9e9e9e', color: '#fff' }}
        />
        <Chip label={BLOCKER_CATEGORY_LABELS[blocker.category] || blocker.category} size="small" variant="outlined" style={{ height: 18, fontSize: 10 }} />
      </div>
      <div style={{ fontSize: 13, fontWeight: 500 }}>{blocker.title}</div>
      {blocker.waiting_on_name && (
        <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>
          Waiting on: {blocker.waiting_on_name}
          {blocker.expected_response_at && ` (expected ${formatDate(blocker.expected_response_at)})`}
        </div>
      )}
      {blocker.blocks_output && (
        <Chip label="Blocks Output" size="small" style={{ height: 18, fontSize: 10, backgroundColor: 'var(--risk-tint, #ffebee)', color: 'var(--risk)', marginTop: 4 }} />
      )}
      {(blocker.status === 'open' || blocker.status === 'waiting' || blocker.status === 'answered') && (
        <Button
          size="small"
          style={{ textTransform: 'none', fontSize: 11, marginTop: 4, color: 'var(--ok)' }}
          onClick={(e) => handleResolve(blocker, e)}
        >
          Resolve
        </Button>
      )}
    </div>
  ))
}

export default BlockersTab
